import { render, staticRenderFns } from "./ApplicationFeatures.vue?vue&type=template&id=5d563bf2&"
import script from "./ApplicationFeatures.vue?vue&type=script&lang=js&"
export * from "./ApplicationFeatures.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFeatures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports